export default __webpack_public_path__ + "static/media/a009-4.247a916d.svg";